<template>
    <ActionButton
        @click='onCreateFolders()'
        text='folders.actions.add_folder'
        icon='fas fa-folder'
        class='clear'
    />

    <ActionButton
        @click='onReloadFolders()'
        text='folders.actions.refresh'
        icon='fas fa-redo-alt'
        class='clear'
    />

    <ActionButton
        @click='onExpandFolders()'
        text='folders.actions.expand_all'
        icon='fas fa-angle-down'
        class='clear'
    />

    <ActionButton
        @click='onCollapseFolders()'
        text='folders.actions.collapse_all'
        icon='fas fa-angle-up'
        class='clear'
    />
</template>

<script setup>
  import {defineProps} from 'vue';
  import ActionButton  from '@/vue/Elements/Buttons/ActionButton.vue';
  import FoldersController from '@/js/Mailboxes/FoldersController';
  import LayoutSettingsController from '@/js/Webmail/LayoutSettingsController';

  const layout_controller  = LayoutSettingsController;
  const folders_controller = FoldersController;

  const props = defineProps({
      webmail_view: Object,
      folders_collapse_collection: Object,
      state_initiator: {
        type: String,
        required: true
      },
  });

  const onCreateFolders = () => {
    folders_controller.collection_state.setInitiator(props.state_initiator);
    props.webmail_view.openFoldersCreate();
  }

  const onReloadFolders = () => {
    folders_controller.fetchBackground();
  }

  const onExpandFolders = () => {
    subFoldersOpen();
    props.folders_collapse_collection.expandAll();
  }

  const onCollapseFolders = () => {
    subFoldersClose();
    props.folders_collapse_collection.collapseAll();
  }

  const subFoldersOpen = () => {
    layout_controller.menu_folders_collapsed = false;
    layout_controller.menu_collapsed         = false;
  }

  const subFoldersClose = () => {
    layout_controller.menu_folders_collapsed = true;
  }
</script>
